import React from 'react';
import classnames from 'classnames';
import CSSClasses from '../../popup-dialog.scss';
export const SubTitle = props => {
  const {
    classes,
    text
  } = props;
  return /*#__PURE__*/React.createElement("span", {
    className: classnames(CSSClasses.subTitle, classes)
  }, text);
};